<div class="replacement-info">
  <div class="replacement-info-title">{{ 'course.replacement' | translate }}</div>
  <div>{{ 'course.replaceOldCourse' | translate }}: {{ course.replaceOld }}</div>
  <div>{{ 'course.replaceNewCourse' | translate }}: {{ course.replaceNew }}</div>
</div>
